import type { SettableLineApprovalState } from '@erp/rpc';
import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';

export type ApprovalTargetPlan =
  { kind: 'skip' } | { kind: 'set' } | { kind: 'commit'; optionId: string };

/**
 * What approving or unapproving one bulk target takes: skip a missing or
 * released line, commit the top option first for a never-committed fill
 * candidate being approved, otherwise just set the state.
 */
export function approvalTargetPlan(
  target: AssignmentLine | undefined,
  state: SettableLineApprovalState,
): ApprovalTargetPlan {
  if (!target || target.approvalState === 'released') return { kind: 'skip' };
  if (state !== 'approved' || target.recommendedAction != null) {
    return { kind: 'set' };
  }
  const optionId = target.topOption?.optionId;
  return optionId == null ? { kind: 'skip' } : { kind: 'commit', optionId };
}
